import { render, staticRenderFns } from "./HelpBox.vue?vue&type=template&id=0b7f5a89&scoped=true&lang=html&"
import script from "./HelpBox.vue?vue&type=script&lang=js&"
export * from "./HelpBox.vue?vue&type=script&lang=js&"
import style0 from "./HelpBox.vue?vue&type=style&index=0&id=0b7f5a89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7f5a89",
  null
  
)

export default component.exports